import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { Card, CardContent } from '../Card';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '../Carousel';
import { SparkleDivider } from '../SparkleDivider';
export function Testimonials() {
  const testimonials = [{
    quote: 'I came home and actually teared up. My house has never looked this good. Maid In Heaven is the real deal.',
    name: 'Jessica M.'
  }, {
    quote: "These ladies are absolute professionals. Punctual, thorough, and so kind. I'll never use anyone else.",
    name: 'Carlos R.'
  }, {
    quote: 'The deep clean they did before my in-laws visited saved my life. Worth every penny.',
    name: 'Danielle P.'
  }, {
    quote: 'It smells like a spa when they leave. The attention to detail is unmatched.',
    name: 'Sarah T.'
  }];
  return <section id="reviews" className="py-24 bg-gradient-to-b from-[#EEF4FB] to-white" data-id="element-204">
      <div className="container mx-auto px-4" data-id="element-205">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-206">
          <h2 className="font-serif text-4xl md:text-5xl text-brand-charcoal mb-4" data-id="element-207">
            Don't Take Our Word For It
          </h2>
          <p className="text-xl text-brand-charcoal/70 font-light" data-id="element-208">
            Real customers. Real results. Heavenly reviews.
          </p>
        </motion.div>

        <div className="max-w-6xl mx-auto mb-20 px-4 md:px-12" data-id="element-209">
          <Carousel opts={{
          align: 'start',
          loop: true
        }} className="w-full" data-id="element-210">
            <CarouselContent className="-ml-4" data-id="element-211">
              {testimonials.map((testimonial, index) => <CarouselItem key={index} className="pl-4 md:basis-1/2 lg:basis-1/3" data-id="element-212">
                  <div className="p-1 h-full" data-id="element-213">
                    <Card className="bg-white border-none shadow-soft rounded-[16px] h-full" data-id="element-214">
                      <CardContent className="p-8 flex flex-col h-full" data-id="element-215">
                        <div className="flex gap-1 mb-6" data-id="element-216">
                          {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-217" />)}
                        </div>
                        <p className="font-serif italic text-lg text-brand-charcoal/80 mb-8 flex-grow" data-id="element-218">
                          "{testimonial.quote}"
                        </p>
                        <div className="mt-auto" data-id="element-219">
                          <p className="font-medium text-brand-charcoal" data-id="element-220">
                            {testimonial.name}
                          </p>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <div className="hidden md:block" data-id="element-221">
              <CarouselPrevious className="-left-12 bg-white border-none shadow-soft hover:bg-brand-white text-brand-blue" data-id="element-222" />
              <CarouselNext className="-right-12 bg-white border-none shadow-soft hover:bg-brand-white text-brand-blue" data-id="element-223" />
            </div>
          </Carousel>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12" data-id="element-224">
          <div className="text-center" data-id="element-225">
            <p className="font-serif text-4xl text-brand-blue mb-2" data-id="element-226">500+</p>
            <p className="text-sm font-medium text-brand-charcoal/60 uppercase tracking-wider" data-id="element-227">
              Homes Cleaned
            </p>
          </div>
          <SparkleDivider className="hidden md:flex py-0 w-auto" data-id="element-228" />
          <div className="text-center" data-id="element-229">
            <p className="font-serif text-4xl text-brand-blue mb-2" data-id="element-230">4.9★</p>
            <p className="text-sm font-medium text-brand-charcoal/60 uppercase tracking-wider" data-id="element-231">
              Average Rating
            </p>
          </div>
          <SparkleDivider className="hidden md:flex py-0 w-auto" data-id="element-232" />
          <div className="text-center" data-id="element-233">
            <p className="font-serif text-4xl text-brand-blue mb-2" data-id="element-234">98%</p>
            <p className="text-sm font-medium text-brand-charcoal/60 uppercase tracking-wider" data-id="element-235">
              Recurring Customers
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}